(() => {
  const initFadeProductCarousel = (section) => {
    if (!section || section.dataset.fadeCarouselInitialized === 'true') return;

    const slides = Array.from(section.querySelectorAll('[data-fade-carousel-slide]'));
    const dots = Array.from(section.querySelectorAll('[data-fade-carousel-dot]'));

    if (!slides.length || !dots.length) return;

    section.dataset.fadeCarouselInitialized = 'true';

    const goToSlide = (index) => {
      slides.forEach((slide, slideIndex) => {
        slide.classList.toggle('is-active', slideIndex === index);
        slide.setAttribute('aria-hidden', slideIndex === index ? 'false' : 'true');
      });

      dots.forEach((dot, dotIndex) => {
        const isActive = dotIndex === index;

        dot.classList.toggle('is-active', isActive);
        dot.setAttribute('aria-selected', isActive ? 'true' : 'false');
      });
    };

    dots.forEach((dot, dotIndex) => {
      dot.addEventListener('click', (event) => {
        event.preventDefault();
        goToSlide(dotIndex);
      });
    });

    goToSlide(0);
  };

  const initAllFadeProductCarousels = () => {
    document
      .querySelectorAll('[data-custom-fade-product-carousel]')
      .forEach(initFadeProductCarousel);
  };

  document.addEventListener('DOMContentLoaded', initAllFadeProductCarousels);

  document.addEventListener('shopify:section:load', (event) => {
    const section = event.target.querySelector('[data-custom-fade-product-carousel]');

    if (section) {
      initFadeProductCarousel(section);
    }
  });

  document.addEventListener('shopify:block:select', (event) => {
    const block = event.target;
    const section = block.closest('[data-custom-fade-product-carousel]');

    if (!section) return;

    const slides = Array.from(section.querySelectorAll('[data-fade-carousel-slide]'));
    const index = slides.indexOf(block);

    if (index === -1) return;

    const dots = Array.from(section.querySelectorAll('[data-fade-carousel-dot]'));

    slides.forEach((slide, slideIndex) => {
      slide.classList.toggle('is-active', slideIndex === index);
      slide.setAttribute('aria-hidden', slideIndex === index ? 'false' : 'true');
    });

    dots.forEach((dot, dotIndex) => {
      const isActive = dotIndex === index;

      dot.classList.toggle('is-active', isActive);
      dot.setAttribute('aria-selected', isActive ? 'true' : 'false');
    });
  });
})();